
const state = {
    cursos:[],
}

const getters = {
    getListCursos: (state) => {
        return state.cursos;
    },
}

const mutations = {
    SET_CURSOS(state, payload) {
        state.cursos = payload;
    },
    RESET_CURSOS(state) {
        state.cursos = [];
    },

}

const actions = {
    setCursos({commit},data) {
        commit('SET_CURSOS',data);
    },
    getInfoCurso({state},nameCurso) {
        var objCurso = {};
        for (var i = 0; i < state.cursos.length; i++) {
            if (state.cursos[i].name == nameCurso) {
                objCurso = state.cursos[i];
                break;
            }
        }
        return objCurso;
    },
    resetCursos({commit}) {
        commit('RESET_CURSOS');
    },
}

export const directorio = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}